import { useCallback, useEffect, useRef, useState } from 'react';
import { jobsApi, pollJob } from '../lib/jobs-api';

/** Poll one processing job (2 s backing off to 10 s) until it settles or the component unmounts. */
export function useJob(jobId, { onSettled } = {}) {
  const [job, setJob] = useState(null);
  const [error, setError] = useState(null);
  const settledRef = useRef(onSettled);
  settledRef.current = onSettled;

  useEffect(() => {
    setJob(null);
    setError(null);
    if (!jobId) return undefined;
    const ctl = new AbortController();
    pollJob(jobId, { signal: ctl.signal, onUpdate: (j) => setJob(j) })
      .then((j) => { if (settledRef.current) settledRef.current(j); })
      .catch((err) => { if (err?.name !== 'AbortError') setError(err); });
    return () => ctl.abort();
  }, [jobId]);

  const cancel = useCallback(() => (jobId ? jobsApi.cancel(jobId) : Promise.resolve()), [jobId]);
  return { job, error, cancel };
}
